const REVALIDATE_TIMEOUT_MS = 5000;

const clearCacheStorage = async (): Promise<void> => {
  if (!('caches' in window)) {
    return;
  }

  const keys = await window.caches.keys();
  await Promise.all(keys.map(key => window.caches.delete(key)));
};

const revalidateDocument = async (): Promise<void> => {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), REVALIDATE_TIMEOUT_MS);

  try {
    await fetch(window.location.href, {
      cache: 'reload',
      credentials: 'same-origin',
      signal: controller.signal,
    });
  } finally {
    window.clearTimeout(timer);
  }
};

/**
 * Reloads the page bypassing caches. `location.reload(true)` is deprecated and
 * ignored by modern browsers, so instead this re-fetches the current URL with
 * `cache: 'reload'` (replacing the browser's HTTP cache entry for the document)
 * and drops CacheStorage entries left behind by previously registered service
 * workers. Asset URLs are content-hashed, so a fresh document implies fresh
 * assets. Failures are ignored — the reload happens regardless.
 */
const hardReload = async (): Promise<void> => {
  await Promise.allSettled([clearCacheStorage(), revalidateDocument()]);
  window.location.reload();
};

export default hardReload;
